module.exports = __webpack_public_path__ + "img/british-flag.524cd45c.svg";